import moment from "moment";
import { payRateTypeObj, shiftTypeObj } from "../../helpers/data";
export const formToSummary = (jobType, startJob, location, shift, jobInfo, education,
    medicalSpeciality, certification, emrEhrSystemExperience,
    covidVaccinationStatus, templateInfo, employerUniqueId, formdata, rrurle, recursionFlag, rrurleStr, JobEncounterOccurreneUpdateList, isAutoPostAllowed,isOvertimeAllowed  ,depsUnits,payRateType,payRateTotalShiftAmount  ,payRateOccurrenceAmount) => {
    const dateDispay = moment(shift?.date, 'YYYY-MM-DD');
    const data = {
        certificationsList: certification?.definedCertification,
        certificationsListOther: certification?.otherCertification,
        employerJobLevelOfEducationIdList: education?.level ? [education?.level] :[],
        employerCovid19VaccinatedPreferencesList: covidVaccinationStatus,
        employerJobEMREHRSystemList: emrEhrSystemExperience?.definedExperience,
        employerJobEMREHRSystemListOther: emrEhrSystemExperience?.otherExperience,
        employerJobLocationsList: [location?.address],
        contactList: location?.contactPersons,
        approverList: location?.approvalUsers,
        employerJobDomainIdList: [jobType?.domain],
        employerJobTypeIdList: [jobType?.type],
        employerJobSpecialtyList: medicalSpeciality?.speciality,
        employerJobSpecialtyListOther: medicalSpeciality?.otherSpeciality,
        shiftStartTime: shift?.startTime?.name,
        shiftEndTime: shift?.endTime?.name,
        shiftHours: shift?.preferedShift?.name,
        shiftDate: shift?.date,
        jobDateToDisplay: dateDispay.format("MM/DD/YYYY"), //new Date(shift?.date).toLocaleDateString(),
        singleShiftEndDate:shift?.singleShiftEndDate,
        employerSpokenLanguagesList: education?.languageSpoken,
        employerOtherSpokenLanguagesList: education?.otherLanguagesSpoken,
        jobTemplateName: templateInfo?.option === 1 ? templateInfo?.name : jobInfo?.jobTemplate?.name,
        jobCategoryId: jobInfo?.jobCategory?.name,
        jobTitle: jobInfo?.jobTitle,
        jobDate: shift?.date,
        jobDescription: jobInfo?.jobDescription,
        incentive: jobInfo?.incentive,
        ratePerHour: jobInfo?.ratePerHour,
        billingrate: jobInfo?.billingrate,
        shiftamount: jobInfo?.shiftamount,
        total: jobInfo?.total,
        templateType: templateInfo?.option,
        dynamicForm: formdata,
        rrurle: rrurle,
        recursionFlag: recursionFlag,
        rrurleStr: rrurleStr,
        JobEncounterOccurreneUpdateList: JobEncounterOccurreneUpdateList,
        isAutoPostAllowed: isAutoPostAllowed ? true : false,
        isOvertimeAllowed : isOvertimeAllowed ? true : false,
        depsUnits:depsUnits,
        payRateType,
        payRateTotalShiftAmount,
        payRateOccurrenceAmount
    }
    return data;
}

export const summaryToForm = (data, masterDatas) => {
    // const singleShiftEndDate = getSingleShiftEndDate(data?.jobDate?.split('T')[0],shift?.startTime?.id,shift?.preferedShift?.id);
    const shiftStartTime =  masterDatas?.allShiftStartTime?.find(startTime => startTime?.id === data?.startTime);
    const preferredShift = masterDatas?.allPreferedShifts?.find(shift => (shift.id === data?.shiftHours))
    return {
        jobType: {
            domain: {
                id: data?.employerJobDomainIdList[0].jobDomainId,
                name: data?.employerJobDomainIdList[0].jobDomain
            },
            type: {
                id: data?.employerJobTypeIdList[0].jobTypeId,
                name: data?.employerJobTypeIdList[0].jobType
            },
        },
        startJob: {
            templateID: '',
            selectedOption: 1
        },
        location: {
            locationNameInfo: {
                id: data?.employerJobLocationsList[0]?.locationId,
                name: data?.employerJobLocationsList[0]?.locationName
            },
            contactPersons: data?.employerJobContactsList,
            approvalUsers: data?.employerJobApprovelList,
            address: {
                locationName: data?.employerJobLocationsList[0]?.locationName,
                zipcode: data?.employerJobLocationsList[0]?.zipcode,
                city: data?.employerJobLocationsList[0]?.city,
                stateName: data?.employerJobLocationsList[0]?.stateName,
                country: data?.employerJobLocationsList[0]?.country,
                latitude: data?.employerJobLocationsList[0]?.approxLatitude,
                longitude: data?.employerJobLocationsList[0]?.approxLongitude,
                streetAddress: data?.employerJobLocationsList[0]?.streetAddress
            }
        },
        shift: {
            startTime: masterDatas?.allShiftStartTime?.find(startTime => startTime?.id === data?.startTime),
            endTime: masterDatas?.allShiftEndTime?.find(endTime => endTime?.id === data?.endTime),
            preferedShift: masterDatas?.allPreferedShifts?.find(shift => (shift.id === data?.shiftHours)),
            date: data?.jobDate?.split('T')[0],
            endDate: data?.jobSummeryJobsShifts?.jobEndDate?.split('T')[0],
            fullFormatDate: data?.jobDate,
            singleShiftEndDate:getSingleShiftEndDate(data?.jobDate?.split('T')[0], shiftStartTime?.id,preferredShift?.id)
        },
        jobInfo: {
            jobTemplate: { id: data?.jobTemplateId, name: data?.jobTemplateName },
            jobCategory: { id: data?.employerJobCategoriesIdList[0]?.jobCategoryId, name: data?.employerJobCategoriesIdList[0]?.description },
            jobTitle: data?.jobTitle,
            jobDescription: data?.jobDescription,
            ratePerHour: data?.ratePerHour,
            incentive:  data?.incentive ?? null,
        },
        education: {
            level: data?.employerJobLevelOfEducationIdList?.length > 0 ? {
                id: data.employerJobLevelOfEducationIdList && data.employerJobLevelOfEducationIdList[0]?.levelOfEducationId,
                name: data.employerJobLevelOfEducationIdList && data.employerJobLevelOfEducationIdList[0]?.levelOfEducationName
            } : undefined ,
            languageSpoken: data?.employerSpokenLanguagesList,
            otherLanguagesSpoken: data?.employerOtherSpokenLanguagesList?.map(lang => (lang.name))
        },
        medicalSpeciality: {
            speciality: data?.employerJobSpecialtyList,
            otherSpeciality: data?.employerJobSpecialtyListOther?.map(lang => ({
                name: lang.name,
                mandatory: lang.mandatory
            }))
        },
        certification: {
            definedCertification: data?.certificationsList,
            otherCertification: data?.certificationsListOther?.map(lang => ({
                name: lang.name,
                mandatory: lang.mandatory
            }))
        },
        emrEhrSystemExperience: {
            definedExperience: data?.employerJobEMREHRSystemList,
            otherExperience: data?.employerJobEMREHRSystemListOther?.map(lang => ({
                name: lang.name,
                mandatory: lang.mandatory
            }))
        },
        covidVaccinationStatus: data?.employerCovid19VaccinatedPreferencesList ? data?.employerCovid19VaccinatedPreferencesList : [],
        templateInfo: {
            option: data?.jobTemplateId,
            name: ''
        },
        jobCode: data?.jobCode,
        jobUnique: data?.jobUniqueId,
        isAutoPostAllowed: data?.isAutoPostAllowed ? true : false,
        isOvertimeAllowed: (+data?.payRateType === payRateTypeObj.manualCal) ? true : data?.isOvertimeAllowed === true ? true : data?.isOvertimeAllowed === false ? false:null,
        // isOvertimeAllowed: (+data?.payRateType === payRateTypeObj.manualCal) ? true : (+data?.payRateType === payRateTypeObj.systemCal) ? false : data?.isOvertimeAllowed === true ? true : data?.isOvertimeAllowed === false ? false:null,
        // depsUnits: data?.jobsShiftsDepartmentsList?.length ? data?.jobsShiftsDepartmentsList?.map(deps => ({id:deps?.id,name:deps?.name})) :[]
        depsUnits: masterDatas?.depsUnitsMaster.find(item => item.id === data?.candidateDepartmentId),
        payRateType:data?.payRateType ?? null,
        payRateTotalShiftAmount:(+data?.payRateType === payRateTypeObj.manualCal) ? data?.manualTotalShiftAmount : null,
        payRateOccurrenceAmount:(+data?.payRateType === payRateTypeObj.manualCal) ? data?.manualAmountPerShift : null
    }
}

export const patchDynamicForm = (original, updateVal) => {
    const newVal = JSON.parse(JSON.stringify(original));
    newVal.forEach(item => {
        const byFormID = updateVal.filter(item1 => item1.formId === item.formId)[0];
        item.controlsInfo.forEach(item3 => {
            if (byFormID) {
                const bySectionID = byFormID.jobProfileSections.filter(item4 => item4.formSectionId === item3.formsSectionID)[0];
                const arr = [];
              
                if (bySectionID.selectedValue?.length) {
                    bySectionID.selectedValue.forEach(item5 => {
                        const filterdata = item3.options.filter(val => val.id === item5)
                        if (filterdata?.length) {
                            arr.push(filterdata[0])
                        }
                    })
                }

                item3.selectedValueOptions = arr
            }
        })
    })
    return newVal
}

export const selectedTemplateToForm = (data, masterDatas, address) => {
    let jobsEMREHRSystemsList = [];
    let jobsSpecialtiesList = [];
    let jobsCertificationsList = [];
    data.jobsEMREHRSystemsList.filter(_ => _.isOther === false)?.forEach(jobExperience => {
        if(masterDatas?.allEmrEhrSystemExperience.find(experience => experience.id === jobExperience.id)?.name){
            jobExperience['name'] = masterDatas?.allEmrEhrSystemExperience.find(experience => experience.id === jobExperience.id)?.name;
            jobsEMREHRSystemsList.push(jobExperience)
        }
    })
    data.jobsSpecialtiesList.filter(_ => _.isOther === false)?.forEach(jobSpeciality => {
        if(masterDatas?.allMedicalSpecialities.find(specialty => specialty.id === jobSpeciality.specialtyId)?.name){
            jobSpeciality['name'] = masterDatas?.allMedicalSpecialities.find(specialty => specialty.id === jobSpeciality.specialtyId)?.name;
            jobsSpecialtiesList.push(jobSpeciality)
        }
    })
    data.jobsCertificationsList.filter(_ => _.isOther === false)?.forEach(certs => {
        if(masterDatas?.allCertifications.find(cert => cert.id === certs.id)?.name){
            const selectedCert = { ...masterDatas?.allCertifications.find(cert => cert.id === certs.id) };
            selectedCert.mandatory = certs.mandatory;
            jobsCertificationsList.push(selectedCert);
        }
        
    })
    return {
        jobType: {
            domain: masterDatas?.allJobDomains?.filter(_ => _.id === data?.jobDomainId)[0],
            type: masterDatas?.allJobTypes?.filter(_ => _.id === data?.jobTypeID)[0],
        },
        startJob: {
            // Template id returned from API is not correct so defaulting
            templateID: masterDatas?.allTemplates.find(template => template.id === data?.jobTemplateId) || undefined,
            selectedOption: 1
        },
        location: {
            locationNameInfo: masterDatas?.allJobLocations?.filter(_ => _.id === data?.locationId)[0] ? masterDatas?.allJobLocations?.filter(_ => _.id === data?.locationId)[0] : {
                id: '',
                name: 'Select'
            },
            contactPersons: arrayCheck(data?.jobsContactsList, masterDatas?.allJobLocationContactPersons),
            approvalUsers: arrayCheck(data?.jobsApproversList, masterDatas?.allJobLocationApprovers),
            address: address
        },
        shift: {
            startTime: masterDatas?.allShiftStartTime?.find(startTime => startTime?.name === data?.shiftStartTime),
            endTime: masterDatas?.allShiftEndTime?.find(endTime => endTime?.name === data?.shiftEndTime),
            preferedShift: masterDatas?.allPreferedShifts?.find(shift => (shift.id === data?.shiftHours)),
            date: '',
            endDate: '',
            singleShiftEndDate:'',
        },
        jobInfo: {
            jobTemplate: { id: data?.jobTemplateId, name: data?.jobTemplateName },
            jobCategory: masterDatas?.allJobCategory?.filter(_ => _.id === data?.jobCategoryId)[0] ? masterDatas?.allJobCategory?.filter(_ => _.id === data?.jobCategoryId)[0] : { id: 0, name: '' },
            jobTitle: data?.jobTitle,
            jobDescription: data?.jobDescription,
            ratePerHour: data?.ratePerHour,
            incentive:  data?.incentive ?? null,
        },
        education: {
            level: data.levelOfEducation ? masterDatas?.allEducationLevels?.filter(_ => _.id === data.levelOfEducation)[0] : undefined,
            languageSpoken: data.jobsSpokenLanguagesList.filter(_ => _.isOther === false)?.map(spokenLng => {
                spokenLng['name'] = masterDatas?.allSpokenLanguages.find(lng => lng.id === spokenLng.spokenLanguage)?.name;
                spokenLng['id'] = spokenLng.spokenLanguage;
                return spokenLng;
            }),
            otherLanguagesSpoken: data.jobsSpokenLanguagesList.filter(_ => _.isOther === true)?.map(_ => {
                return _.otherSpokenLanguage;
            }),
        },
        medicalSpeciality: {
            speciality: jobsSpecialtiesList,
            otherSpeciality: data.jobsSpecialtiesList.filter(_ => _.isOther === true)?.map(_ => {
                return {
                    name: _.otherName,
                    yearsOfExperience: _.yearsOfExperience
                }
            }),
        },
        certification: {
            definedCertification: jobsCertificationsList,
            otherCertification: data.jobsCertificationsList.filter(_ => _.isOther === true)?.map(_ => {
                return {
                    name: _.otherName,
                    mandatory: _.mandatory
                }
            }),
        },
        emrEhrSystemExperience: {
            definedExperience: jobsEMREHRSystemsList,
            otherExperience: data.jobsEMREHRSystemsList.filter(_ => _.isOther === true)?.map(_ => {
                return {
                    name: _.otherName,
                    mandatory: _.mandatory
                }
            }),
        },
        covidVaccinationStatus: data?.employerCovid19VaccinatedPreferencesList ? data?.employerCovid19VaccinatedPreferencesList : [],
        templateInfo: {
            option: '',
            name: '',
        },
        isAutoPostAllowed: data?.isAutoPostAllowed ? true : false, 
        isOvertimeAllowed: (+data?.payRateType === payRateTypeObj.manualCal) ? true : (+data?.payRateType === payRateTypeObj.systemCal) ? false : null,
        // isOvertimeAllowed: (+data?.payRateType === payRateTypeObj.manualCal) ? true : (+data?.payRateType === payRateTypeObj.systemCal) ? false : data?.isOvertimeAllowed === true ? true : data?.isOvertimeAllowed === false ? false:null,
        // depsUnits: data?.jobsShiftsDepartmentsList?.length ? data?.jobsShiftsDepartmentsList?.map(deps => ({id:deps?.id,name:deps?.name})) :[]
        depsUnits: masterDatas?.depsUnitsMaster.find(item => item.id === data?.candidateDepartmentId),
        payRateType:data?.payRateType ?? null,
        payRateTotalShiftAmount: (+data?.payRateType === payRateTypeObj?.manualCal) ? data?.manualTotalShiftAmount : null,
        payRateOccurrenceAmount: (+data?.payRateType === payRateTypeObj?.manualCal) ? data?.manualAmountPerShift : null
    }
}

const arrayCheck = (data, masterData) => {
    const newVal = []
    data?.forEach(item1 => {
        const val = masterData?.find(item2 => item2.id === item1?.employerUserId);
        if (val) {
            newVal.push(val);
        }
    })
    return newVal;
}

export const updateShiftTime = ({currentValue,updateField,shiftStartTime,masterData,shiftStartDate,shiftType}) => {
    if(updateField === "preferedShift"){
        const startTime = moment(shiftStartTime, 'hh:mm');
        const endTime = moment(currentValue, 'hh:mm');
        const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
        let originalMins = 0;
        const dayInMins = 24 * 60;
        if(InMinutes > 0){
            originalMins = InMinutes;
        } else {
            originalMins =  dayInMins + InMinutes;
        }
        // console.log({originalMins,InMinutes});
        const lastItem = masterData.at(-1)
        let updatePreferredShift;
        const result = masterData?.find(item => item?.id === originalMins);
        if(result){
            updatePreferredShift = result
        } else if(originalMins > lastItem?.id){
            updatePreferredShift = lastItem
        }
        let shiftEndDate ="";
        if(shiftStartDate && +shiftType === shiftTypeObj.singleShift && result && shiftStartTime){
            const shiftStartDateTime = moment(shiftStartDate+" "+shiftStartTime, "YYYY-MM-DD hh:mm A");
            const hours = originalMins / 60;
            const minutes = originalMins % 60;

            const shiftEndDateTime = shiftStartDateTime.add(hours,'hours').add(minutes,'minute');
             shiftEndDate = shiftEndDateTime.format("YYYY-MM-DD");
            console.log({shiftStartDateTime:shiftStartDate+" "+shiftStartTime,shiftEndDateTime,shiftEndDate});
  
          } 
        // console.log({updatePreferredShift});
        return {
            "field":updateField,
            "data":updatePreferredShift,
            "singleShiftEndDate":shiftEndDate
        }

    }
    if(updateField === "endTime"){
        const hours = Math.floor(parseInt(currentValue) / 60);
        const minutes = parseInt(currentValue) % 60;
        const actualEndTime = moment(shiftStartTime, 'hh:mm A')
        .add(hours, 'hours')
        .add(minutes, 'minute')
        .format('hh:mm A');
        const updateEndTime = masterData?.find(
          (item) => item?.name === actualEndTime
        )
        let shiftEndDate="";
        if(shiftStartDate && +shiftType === shiftTypeObj.singleShift && currentValue && shiftStartTime){
          const shiftStartDateTime = moment(shiftStartDate+" "+shiftStartTime, "YYYY-MM-DD hh:mm A");
          const shiftEndDateTime = shiftStartDateTime.add(hours,'hours').add(minutes,'minute');
           shiftEndDate = shiftEndDateTime.format("YYYY-MM-DD");
          console.log({shiftStartDateTime:shiftStartDate+" "+shiftStartTime,shiftEndDateTime,shiftEndDate});

        } 
        return {
            "field":updateField,
            "data":updateEndTime,
            "singleShiftEndDate":shiftEndDate
        }
    }
}

export function getSingleShiftEndDate(startDate, startTime,shiftLength){
    let shiftEndDate = startDate;
    if(startDate && startTime && shiftLength){
        const shiftStartDateTime = moment(startDate+" "+startTime, "YYYY-MM-DD hh:mm A");
        const hours = Math.floor(parseInt(shiftLength) / 60);
        const minutes = shiftLength % 60;
        const shiftEndDateTime = shiftStartDateTime.add(hours,'hours').add(minutes,'minute');
        shiftEndDate =  shiftEndDateTime.format("YYYY-MM-DD")
    }
    return shiftEndDate
}

// var newDateObj = moment(new Date(modifyTime)).add(-15, 'm').toDate();
export const getMinMaxTime = (startTime,hours,mins) => {
    const startDateTime = new Date(startTime);
    const newDate = moment(startDateTime).add(hours,'hours').add(mins,'minutes').toDate();
    return newDate ?? startTime;
}

